import { Box, FormControl, MenuItem, Select, Typography } from '@mui/material';
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { DateColumnConfigDto } from '../../../types';

interface DateColumnConfigEditorProps {
  config: DateColumnConfigDto;
  onTypeChange: (config: DateColumnConfigDto) => void;
}

const DATE_FORMATS = [
  { formatLabel: 'dd-mm-yy', value: 'dd-MM-yy' },
  { formatLabel: 'dd-mmm-yy', value: 'dd-MMM-yy' },
  { formatLabel: 'dd/mm/yy', value: 'dd/MM/yy' },
  { formatLabel: 'dd/mm/yyyy', value: 'dd/MM/yyyy' },
];

export function DateColumnConfigEditor({ config, onTypeChange }: DateColumnConfigEditorProps) {
  const { $t } = useIntl();

  const formatsWithLabels = useMemo(() => {
    const now = DateTime.now();
    return DATE_FORMATS.map((format) => ({
      ...format,
      label: `${format.formatLabel} (${now.toFormat(format.value)})`,
    }));
  }, []);

  const handleFormatChange = (format: string) => {
    onTypeChange({
      ...config,
      format,
    });
  };

  return (
    <Box marginTop={2}>
      <FormControl size="small">
        <Typography variant="caption" color="text.secondary" gutterBottom>
          {$t({
            id: 'audit.reportDefinitionEditor.columnType.date.format',
            defaultMessage: 'Formato de fecha',
          })}
        </Typography>
        <Select value={config.format} onChange={(e) => handleFormatChange(e.target.value)} required>
          {formatsWithLabels.map((format) => (
            <MenuItem key={format.value} value={format.value}>
              {format.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
